import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listBadges: [],
};

const badgeSlice = createSlice({
  name: "badges",
  initialState,
  reducers: {
    setListBadges: (state, action) => {
      state.listBadges = action.payload.listBadges;
    },
    clearListBadges: (state) => {
      state.listBadges = [];
    },
  },
});

export const { setListBadges, clearListBadges } = badgeSlice.actions;
export default badgeSlice.reducer;
